function ExamplePage() {
    return (
        <div className="pt-16 container mx-auto">
            Example Page
        </div>
    );
}

export default ExamplePage;
